import { SvgIcon, SvgIconProps } from "@mui/material";

const LeafIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 24 24" {...props}>
			<g transform="translate(2, 2)">
				<path
					d="M10 9.99967H7.5C6.17392 9.99967 4.90215 9.47289 3.96447 8.53521C3.02678 7.59753 2.5 6.32576 2.5 4.99967V3.33301H5C6.32608 3.33301 7.59785 3.85979 8.53553 4.79747C9.47322 5.73516 10 7.00693 10 8.33301V16.6663M10 11.6663C10 10.3403 10.5268 9.06849 11.4645 8.13081C12.4021 7.19313 13.6739 6.66634 15 6.66634H17.5V7.49967C17.5 8.82576 16.9732 10.0975 16.0355 11.0352C15.0979 11.9729 13.8261 12.4997 12.5 12.4997H10"
					fill="none"
					stroke="#FAFAFA"
					strokeOpacity="0.85"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</SvgIcon>
	);
};

export default LeafIcon;
